import { Script } from "gatsby-script";
import React from "react";

export default function AdSenseScript() {
  return (
    <Script
      src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-9325511402488162"
      crossOrigin="anonymous"
    />
  );
}
